import { z } from "zod";
import { regularQuestionSchema } from "./RegularQuestion";
import { simpleQuestionSchema } from "./SimpleQuestion";

export const questionSchema = z.discriminatedUnion("type", [
  simpleQuestionSchema,
  regularQuestionSchema,
]);

export type Question = z.infer<typeof questionSchema>;
